import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Question} from '../../models/underwriter.model';

@Component({
    selector: 'app-question-percentage-variation-two',
    templateUrl: './question-percentage-variation-two.component.html',
    styleUrls: ['./question-percentage-variation-two.component.scss'],
    standalone: false
})
export class QuestionPercentageVariationTwoComponent implements OnInit {

  @Input() headerTitle = 'Activities';
  @Input() placeHolderText = 'Describe activity';
  @Input() percentAmount = 100;
  @Input() question: Question;
  @Input() allowDelete = false;
  activities: any[] = [];
  @Output() questionAnswer = new EventEmitter<any>();

  idCount = 0;

  constructor() { }

  ngOnInit(): void {
    if (this.question && this.question.answer) {
      for (const a of this.question.answer) {
        this.idCount += 1;
        this.activities.push({id: this.idCount, value: '', percent: '', valueInvalid: false, percentInvalid: false});
      }
    } else {
      this.idCount += 1;
      this.activities.push({id: this.idCount, value: '', percent: '', valueInvalid: false, percentInvalid: false});
    }
  }

  addAnotherActivity(): void {
    this.idCount += 1;
    if (!this.activities.some(a => !a.value || !a.percent)) {
      this.activities.push({id: this.idCount, value: '', percent: '', valueInvalid: false, percentInvalid: false});
    }
    this.activities.forEach(a => {
      if (!a.value || !a.percent) {
        a.valueInvalid = !a.value;
        a.percentInvalid = !a.percent;
        return;
      }
    });
  }

  deleteActivity(activity: any): void {
    const itemIndex = this.activities.findIndex(i => i.id === activity.id);

    if (itemIndex > -1) {
      this.activities.splice(itemIndex, 1);
    }
  }

  onModelChange(activity: any, type): void {
    if (type === 'value') { activity.valueInvalid = !activity.value; }
    if (type === 'percent') { activity.percentInvalid = !activity.percent; }

    if (!this.activities.some(a => a.valueInvalid || a.percentInvalid)) {
      this.questionAnswer.emit(this.activities);
    }
  }

  get totalAmount(): number {
    let total = 0;
    for (const a of this.activities) {
      total += +a.percent;
    }
    return total;
  }

}
